import { render } from "./reports/report-tpl.html?vue&type=template&id=67a99f0b"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\release-RPTWEB-3376\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__